import React from 'react';
import { Course } from '../../types/grades';
import { GPADisplay } from '../GPADisplay';
import { GPATable } from '../GPATable';

interface GPASidebarProps {
  courses: Course[];
  cumulativeGPA: number;
}

export function GPASidebar({ courses, cumulativeGPA }: GPASidebarProps) {
  return (
    <div className="space-y-6">
      <GPADisplay courses={courses} cumulativeGPA={cumulativeGPA} />
      <GPATable />
    </div>
  );
}